import React from 'react'
import { Featured } from './index'
import {
  FloatingFilter,
  AlertEmpty,
} from '../../../components'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import { useSelector } from 'react-redux'
// import { QUERY_BLACKLIST as BLACKLIST } from '../../../constants'
import PaginatedList from './paginated-list'

const MainContentMobile = ({
  uniform,
  embed,
  pageConfig,
  actions
}) => {
  const { data } = useSelector(state => state.blogs)
  const query = qs.parse(useLocation().search)
  const queryKeys = Object.keys(query)
  // const keyFilter = key => BLACKLIST.includes(key) === false
  // const filteredKeys = queryKeys.filter(keyFilter)
  // const filtered = query && filteredKeys.length > 0
  const filtered = queryKeys.length > 0

  return (
    <div className={`${embed ? '' : 'pt-5'}`}>
      {
        !filtered &&
        <Featured embed={embed}/>
      }
      <section className={`container mx-auto ${embed ? 'pb-2' : 'pb-8'}`}>
        {
          (data && data.length > 0) ? (
            <PaginatedList
              query={query}
              defaultData={data}
              pageConfig={pageConfig}
              actions={actions}
            />
          ) : (
            <AlertEmpty />
          )
        }
      </section>
      <FloatingFilter filterOptions={{
        keyword: false,
        location: false,
        type: true,
        date: true,
        category: true
      }}/>
    </div>
  )
}

export { MainContentMobile }
